import React from 'react'

const Clearfix = () => {
    return <div className="clearfix"></div>
}

export default Clearfix